import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { placeholderName } from "../Utils/general";

const OrgCards = ({ orgImage, orgName = "", id, orgParent = "", showAppCount, showResourceCount, showAmount, appCount = "", resourceCount = "", amount = "", manage = false, handleClickManage }) => {

  const handleClick = (id) => {
    if (handleClickManage) {
      handleClickManage(id)
    }
  }

  return (
    <div className="org-card">
      <div className="profile">
        <UserProfile path={orgImage} name={orgName} />
      </div>
      <div className="names-info">
        <p className="name" title={orgName} >{orgName}</p>
        {orgParent && <p className="p-name" title={orgParent} >{orgParent}</p>}
      </div>
      <div className="counts-here">
        {showAppCount && <span className="count-item">
          <h6>{appCount}</h6>
          <p>Applications</p>
        </span>}
        {showResourceCount && <span className="count-item">
          <h6>{resourceCount}</h6>
          <p>Resources</p>
        </span>}
      </div>

      {(showAmount || manage) ?
        <div className="action-item">
          {showAmount && <p className="amount">₹{amount}</p>}
          {manage && <button onClick={() => handleClick(id)} className="action-btn">Manage</button>}
        </div>
        :
        ""
      }
    </div>
  );
};

export default OrgCards;

export const UserProfile = ({ path, name = "" }) => {

  const [profileError, setProfileError] = useState(false);

  const handleImageError = () => {
    setProfileError(true);
  };

  return (
    <>
      <div className="for-border">
        {(profileError || !path) ?
          <span className="initials"> {placeholderName(name || "")} </span>
          :
          <img
            src={path}
            onError={handleImageError}
            referrerPolicy={"no-referrer"}
            className="group-image" />
        }
      </div>
    </>
  )

}